module.exports = __webpack_public_path__ + "static/media/wrong.1776a141.mp3";